var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -0.00035 13.74215 -0.00035 13.74215 13.74215 0 13.74215"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-5.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5674,13.5674 C13.3344,13.8004 12.9524,13.8004 12.7194,13.5674 L6.8714,7.7194 L1.0234,13.5674 C0.7904,13.8004 0.4084,13.8004 0.1744,13.5674 C-0.0586,13.3344 -0.0586,12.9524 0.1744,12.7184 L6.0234,6.8714 L0.1744,1.0234 C-0.0586,0.7904 -0.0586,0.4084 0.1744,0.1744 C0.4084,-0.0586 0.7904,-0.0586 1.0234,0.1744 L6.8714,6.0224 L12.7194,0.1744 C12.9524,-0.0586 13.3344,-0.0586 13.5674,0.1744 C13.8004,0.4084 13.8004,0.7904 13.5674,1.0234 L7.7194,6.8714 L13.5674,12.7194 C13.8004,12.9524 13.8004,13.3344 13.5674,13.5674",
    id: "Fill-1",
    fill: "#ABB7CE",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseGray);
export default __webpack_public_path__ + "static/media/ic_close_gray.58766c54.svg";
export { ForwardRef as ReactComponent };